module.exports = __webpack_public_path__ + "static/img/icon12.0715d338.png";